<template>
  <!-- дублирует статус загрузки и окно «Лог загрузки» — для скринридеров скрыта -->
  <div class="ws-feed" :class="{ 'ws-feed-clearing': clearing }" aria-hidden="true">
    <transition-group name="wsf" tag="div" class="wsf-list">
      <div v-for="(item, idx) in items" :key="item.id" class="wsf-item" :class="'wsf-' + item.level">
        <div class="wsf-body" :class="'wsf-age-' + (items.length - 1 - idx)">
          <span class="wsf-msg">{{ item.message }}</span>
          <span class="wsf-time">{{ ago(item.at) }}</span>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
// Лента WS-сообщений сервера (вариант «Таймлайн»): последние MAX сообщений
// на свободном поле справа от расписания. Источник — тот же массив
// messages, что показывает окно «Лог загрузки».
const MAX = 4
const IDLE_MS = 30000

// сервер присылает произвольный CSS-цвет; белый по умолчанию не виден на
// светлой теме — сводим к уровням из токенов темы
function levelOf(color) {
  const c = String(color || 'white').toLowerCase()
  if (c === 'red') return 'error'
  if (c === 'lawngreen' || c === '#8bc34a' || c === 'green') return 'success'
  if (c === 'yellow' || c === '#9d9d11') return 'warning'
  return 'info'
}

export default {
  name: 'wsFeed',
  props: {
    messages: { type: Array, default: () => [] },
  },
  data() {
    return {
      items: [],
      seen: this.messages.length,
      now: Date.now(),
      lastAt: 0,
      nextId: 1,
      timer: null,
      clearing: false,
    }
  },
  watch: {
    'messages.length'(len) {
      // массив могли заменить/очистить — начинаем отсчёт заново
      if (len < this.seen) this.seen = 0
      this.messages.slice(this.seen).forEach(m => this.add(m))
      this.seen = len
    },
  },
  mounted() {
    this.timer = setInterval(this.tick, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    // устаревшая лента не нужна: через IDLE_MS без новых сообщений
    // плавно гасим и очищаем её целиком
    tick() {
      this.now = Date.now()
      if (this.items.length && this.now - this.lastAt > IDLE_MS) {
        this.clearing = true
        this.items = []
      }
    },
    add(m) {
      if (!m || !m.message) return
      this.clearing = false
      const at = Date.now()
      this.items.push({ id: this.nextId++, message: String(m.message), level: levelOf(m.color), at })
      if (this.items.length > MAX) this.items.splice(0, this.items.length - MAX)
      this.lastAt = at
      this.now = at
    },
    ago(at) {
      const s = Math.round((this.now - at) / 1000)
      if (s < 3) return 'сейчас'
      if (s < 60) return `${s} с назад`
      return `${Math.floor(s / 60)} мин назад`
    },
  },
}
</script>

<style scoped>
/* Только на широких экранах: колонка расписания — 700px по центру,
   лента живёт в правом свободном поле и не перехватывает клики. */
.ws-feed {
  display: none;
}
@media (min-width: 1260px) {
  .ws-feed {
    display: block;
    position: fixed;
    right: 28px;
    bottom: 96px;
    width: clamp(240px, calc((100vw - 700px) / 2 - 64px), 340px);
    z-index: 50;
    pointer-events: none;
  }
}

.wsf-list {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 12px;
  padding-left: 20px;
}
/* нить таймлайна, тающая кверху */
.wsf-list::before {
  content: "";
  position: absolute;
  left: 5px;
  top: 0;
  bottom: 6px;
  width: 1px;
  background: linear-gradient(to top, var(--border), transparent);
}

.wsf-item {
  position: relative;
  font-size: 13px;
  line-height: 1.35;
  color: var(--text);
}
.wsf-info { --wsf-lvl: var(--text-muted); }
.wsf-success { --wsf-lvl: var(--success); }
.wsf-warning { --wsf-lvl: var(--warning); }
.wsf-error { --wsf-lvl: var(--danger); }

/* узел на нити: цвет — уровень сообщения */
.wsf-item::before {
  content: "";
  position: absolute;
  left: -19px;
  top: 5px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--bg);
  border: 2px solid var(--wsf-lvl);
}
.wsf-item:last-child::before {
  background: var(--wsf-lvl);
  animation: wsf-pulse 1.6s ease-out 2;
}
.wsf-error .wsf-msg {
  color: var(--danger);
}
.wsf-msg {
  overflow-wrap: anywhere;
}
.wsf-time {
  display: block;
  font-size: 11px;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

/* старые сообщения уменьшаются и тают; transform — на внутреннем блоке,
   чтобы не спорить с FLIP-сдвигом transition-group на внешнем */
.wsf-body {
  transform-origin: left bottom;
  transition: opacity .6s ease, transform .6s ease;
}
.wsf-age-1 { opacity: .7; }
.wsf-age-2 { opacity: .45; transform: scale(.97); }
.wsf-age-3 { opacity: .25; transform: scale(.94); }
/* очистка по простою — медленнее обычного ухода, без рывка */
.ws-feed-clearing .wsf-leave-active {
  transition: opacity 1.4s ease, transform 1.4s ease;
}

/* появление снизу, уход вверх, плавный сдвиг остальных */
.wsf-enter-active,
.wsf-leave-active {
  transition: opacity .6s ease, transform .45s cubic-bezier(.2, .8, .2, 1);
}
.wsf-enter {
  opacity: 0;
  transform: translateY(14px);
}
.wsf-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.wsf-move {
  transition: transform .45s cubic-bezier(.2, .8, .2, 1);
}

@keyframes wsf-pulse {
  0% { box-shadow: 0 0 0 0 var(--wsf-lvl); }
  100% { box-shadow: 0 0 0 9px transparent; }
}

@media (prefers-reduced-motion: reduce) {
  .wsf-enter-active,
  .wsf-leave-active,
  .wsf-move,
  .wsf-body {
    transition: opacity .3s linear;
    transform: none;
  }
  .wsf-enter { transform: none; }
  .wsf-leave-to { transform: none; }
  .wsf-item:last-child::before { animation: none; }
}
</style>
